var _defs, _rect, _circle, _circle2, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomDevelopmentHeroLuminousSystemBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1600,
    height: 1000,
    viewBox: "0 0 1600 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Custom development luminous system background") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero-bg-blue"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F8FC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero-bg-pink"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F8FC",
    stopOpacity: 0
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1600,
    height: 1000,
    fill: "#F5F8FC"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1350,
    cy: 110,
    r: 430,
    fill: "url(#hero-bg-blue)",
    opacity: 0.72
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 940,
    r: 300,
    fill: "url(#hero-bg-pink)",
    opacity: 0.45
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#72BFFF",
    opacity: 0.26
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1210,
    cy: 360,
    r: 250
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1210,
    cy: 360,
    r: 330
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1210,
    cy: 360,
    r: 410
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90 900L1450 50M100 190h420M1100 820h360"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#087CFF",
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 210,
    cy: 160,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 650,
    cy: 640,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1460,
    cy: 510,
    r: 5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomDevelopmentHeroLuminousSystemBackground);
export default __webpack_public_path__ + "static/media/custom-development-hero-luminous-system-background.9a12e0eeae96df69596952b0f91e4d46.svg";
export { ForwardRef as ReactComponent };